import { Slide } from '@/components/core/Slide';

export const slide = () => {
  return (
    <Slide
      notes="EVA system initialization sequence"
      visualizer="full"
      // autoNext={10000}
      transition="fade"
      terminal={{
        phases: [
          {
            type: 'command',
            content: '♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡',
          },
          {
            type: 'command',
            content: '♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡',
          },
          {
            type: 'command',
            content: '♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡',
          },
          {
            type: 'command',
            content: '♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡',
          },
          {
            type: 'command',
            content: '♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡',
          },
          {
            type: 'command',
            content: '♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡',
          },
          {
            type: 'command',
            content: '♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡',
          },
          {
            type: 'command',
            content: '♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡',
          },
          {
            type: 'command',
            content: '♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡',
          },
          {
            type: 'command',
            content: '♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡',
          },
          {
            type: 'command',
            content: '♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡',
          },
          {
            type: 'command',
            content: '♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡♡',
          },
        ],
        config: {
          title: 'EVA',
          typingSpeed: 200,
          phaseDelay: 300,
        },
      }}
    >
      <div className="absolute inset-0 z-0" />
    </Slide>
  );
};
